module.exports = __webpack_public_path__ + "media/images/bg/headers/pricing-d1688b4b13c821e734d07dc659bfef17.png";